module.exports = __webpack_public_path__ + "img/image7.0d6917e9.png";